import { render, staticRenderFns } from "./DoctorsUtility.vue?vue&type=template&id=782f47d9"
import script from "./DoctorsUtility.vue?vue&type=script&lang=js"
export * from "./DoctorsUtility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports